export default __webpack_public_path__ + "static/smashing-logo-cbc2feaea03a3b2c262d49eab5457f46.svg";